import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "title", "options", "value", "defaultValue", "valueChange", "onChange", "error", "errMessage", "radioDirection", "disabled"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "valueChange", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useState } from 'react';
import { Box, FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JoveRadioGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      title = props.title,
      options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      onChange = props.onChange,
      error = props.error,
      errMessage = props.errMessage,
      _props$radioDirection = props.radioDirection,
      radioDirection = _props$radioDirection === void 0 ? 'horizontal' : _props$radioDirection,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue || ''),
      selectValue = _useState[0],
      setSelectValue = _useState[1];
  /**
   * methods
   */


  var valueChangeAction = function valueChangeAction(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    var tempValue = e.target.value;
    setSelectValue(tempValue);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(tempValue);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsxs(FormControl, {
      children: [!!title && /*#__PURE__*/_jsx(FormLabel, {
        id: "row-radio-buttons-group-label",
        children: title
      }), /*#__PURE__*/_jsx(RadioGroup, _objectSpread(_objectSpread({}, rest), {}, {
        row: true,
        ref: ref,
        value: value === undefined ? selectValue : value || '',
        defaultValue: defaultValue,
        onChange: valueChangeAction,
        children: /*#__PURE__*/_jsx(Box, {
          className: clsx('flex', radioDirection === 'horizontal' ? 'flex-row' : 'flex-col'),
          children: (options || []).map(function (item) {
            return /*#__PURE__*/_jsx(FormControlLabel, {
              value: item.value,
              control: /*#__PURE__*/_jsx(Radio, {}),
              label: item.label,
              disabled: item.disabled || disabled
            }, item.value);
          })
        })
      }))]
    }), error && /*#__PURE__*/_jsx(FormHelperText, {
      error: error,
      children: errMessage
    })]
  });
});
export var JoveRadioGroupControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;
  /**
   * methods
   */


  var valueChangeAction = function valueChangeAction(value) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveRadioGroup, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      valueChange: valueChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveRadioGroup;